<template>
  <div class="container">
    <div class="inside-banner">
      <!-- ElementUI轮播图 -->
      <el-carousel
          class="banner-carousel"
          indicator-position="none"
          loop
          autoplay
          arrow="never"
      >
        <el-carousel-item v-for="(item, index) in topImgList" :key="index">
          <a class="banner-link" href="" target="">
            <img
                :src="item.src"
                :alt="item.title"
                class="carousel-img"
            />
          </a>
        </el-carousel-item>
      </el-carousel>

      <!-- 面包屑 -->
      <div class="crumbs">
        <p>
          <a href="/table" target="">首页</a> /
          <a href="" target="">{{currentArticleLabel}}</a>
        </p>
      </div>
    </div>

    <div class="container-content">
      <!-- 左侧文章内容 -->
      <div class="fl art-content" v-loading="loading">
        <h1>{{formData.title}}</h1>
        <div class="art-time">
          <span>发布时间：{{formData.time}}</span>
        </div>
        <!-- 富文本内容区域 -->
        <div class="art-body" v-html="formData.content"></div>
        <div class="turn-page">
          <div class="prev-article">上一篇：
            <a v-if="formData.previous"  :href="`/article?articleId=${formData.previous}&type=${articleType}`">{{formData.previousName}}</a>
            <a v-else href="">没有了</a>
          </div>
          <div class="next-article">下一篇：
            <a v-if="formData.next"  :href="`/article?articleId=${formData.next}&type=${articleType}`">{{formData.nextName}}</a>
            <a v-else href="">没有了</a>
          </div>
          <a v-if="articleType===NodeIdEnum.ARTICLE_TYPE_QZ_ID.value" class="back" href="/table" target="">返回首页 ></a>
          <a v-else class="back" :href="`/articleHome?articleType=${articleType}`" target="">返回列表 ></a>
        </div>
      </div>

      <!-- 右侧相关新闻 -->
      <div class="fr relate-news pc-nr">
        <h2>相关新闻<a :href="`/articleHome?articleType=${articleType}`" target="">更多 ></a></h2>
        <ul>
          <li v-for="(item, index) in articleList" :key="index">
            <a @click="handNewsList(item.id)">
              <p><span>{{item.year}}</span><em>{{item.monthDay}}</em></p>
              <h3>{{ item.title }}</h3>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {getImgList, selectListByArticle} from "@/api/home";
import {NodeIdEnum} from "@/enums/nodeIdEnum";
import {ImageTypeEnum} from "@/enums/imageTypeEnum";

export default {
  name: 'CaseBanner',
  computed: {
    NodeIdEnum() {
      return NodeIdEnum
    },
    // 根据type值获取对应的分类名称（调用枚举的工具方法）
    currentArticleLabel() {
      return NodeIdEnum.getLabelByValue(this.articleType);
    },
  },
  data() {
    return {
      loading: false,
      topImgList:'',
      articleList:[],
      articleType:'',
      formData:{
        url:'',
        time:'',
        title: '',
        content:'',
        previous:'',
        previousName:'',
        next:'',
        nextName:'',
        articleList:[]
      }
    };
  },
  watch: {
    // 监听路由参数变化，重新获取产品详情
    "$route.query": {
      immediate: true, // 初始化时立即执行
      handler(newQuery) {
        const { articleId,type } = newQuery;
        if (articleId && type) {
          this.articleType = type;
          this.selectListByArticle(articleId,type);
        } else {
          this.$message.warning("文章参数不能为空");
          this.richTextContent = "";
        }
      },
    },
  },
  created() {
    this.getBannerList();
  },
  methods: {
    //获取图片
    async getBannerList() {
      try {
        this.loading = true;
        const res = await getImgList(ImageTypeEnum.TABLE_ARTICLE_LIST.value);
        const dataList = res.data || [];
        this.topImgList = dataList.filter(item => item.classify === ImageTypeEnum.TABLE_ARTICLE_LIST.value && item.src);
      } catch (error) {
        console.error("获取轮播图失败：", error);
        this.$message?.error("轮播图加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    //根据文章id获取文章详情
    async selectListByArticle(articleId,type) {
      try {
        this.loading = true;
        const res = await selectListByArticle(articleId,type);
        if (res.code === 200) {
          this.formData = res.data ||[];
          this.articleList = this.formData.articleList;
        } else {
          this.$message.error(res.msg || "获取文章详情失败");
        }
      } catch (error) {
        console.error("文章详情请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    //相关新闻点击事件
    handNewsList(id){
      this.$router.push({ path: '/article', query: { articleId: id, type:this.articleType } });
    },
  }
}
</script>

<style scoped lang="scss">
// 统一盒模型
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
// 基础浮动类（兼容旧类名）
.fl { float: left; }
.fr { float: right; }
// 清除浮动
.clearfix::after {
  content: '';
  display: block;
  clear: both;
}

.container{
  position: relative;
  width: 100%;
  max-width: 1920px; // 限制最大宽度，适配大屏
  margin: 0 auto;
  padding: 0 15px; // 移动端全局左右内边距，避免内容贴边
}

// Banner容器
.inside-banner {
  position: relative;
  margin-top: 100px;
  width: 100%;
  overflow: hidden;

  // 平板适配
  @media (max-width: 768px) {
    margin-top: 80px;
  }
  // 手机适配
  @media (max-width: 480px) {
    margin-top: 60px;
    // 移动端改为flex布局，让轮播和面包屑上下排列
    display: flex;
    flex-direction: column;
  }
}

// ElementUI轮播图容器样式
.banner-carousel {
  width: 100%;
  height: 280px !important;

  :deep(.el-carousel__container) {
    height: 100%;
  }

  :deep(.el-carousel-item) {
    height: 100%;
  }
}

// 轮播图链接
.banner-link {
  display: block;
  width: 100%;
  height: 100%;
}

// 轮播图图片样式
.carousel-img {
  width: 100%;
  height: 100%;
  // 改为contain确保图片完整显示，而非cover裁剪
  //object-fit: contain;
  object-position: center;
  // 移动端强制图片宽度100%，高度自适应
  @media (max-width: 480px) {
    height: auto !important;
  }
}

// 面包屑容器
.crumbs {
  position: absolute;
  bottom: 38px;
  left: 9%;
  width: 82%;
  padding: 20px 30px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  // 平板适配
  @media (max-width: 768px) {
    bottom: 20px;
    left: 5%;
    width: 90%;
    padding: 15px 20px;
  }
  // 手机适配
  @media (max-width: 480px) {
    // 取消绝对定位，改为默认流布局
    position: static;
    // 重置位置和间距
    bottom: auto;
    left: auto;
    width: 100%;
    // 调整内边距
    padding: 15px 10px;
    // 增加顶部间距，和轮播图分开
    margin-top: 10px;
    // 毛玻璃效果保留
    backdrop-filter: blur(2px);
  }
}

// 面包屑文本
.crumbs p {
  color: #666; // 加深字体颜色，提升移动端可读性
  font-size: 12px;
  line-height: 20px;

  // 手机适配
  @media (max-width: 480px) {
    font-size: 11px;
    line-height: 18px;
  }
}

// 面包屑链接
.crumbs p a {
  display: inline-block;
  vertical-align: top;
  margin: 0 10px;
  color: #666;
  text-decoration: none;
  transition: color 0.2s ease;

  &:first-child {
    margin-left: 0;
  }

  &:hover {
    color: #d26b6b; // 统一hover颜色
  }

  // 手机适配
  @media (max-width: 480px) {
    margin: 0 5px;
  }
}

/* 核心：文章+相关新闻布局（Flex实现左右分栏） */
.container-content{
  position: relative;
  max-width: 1600px;
  margin: 0 auto;
  display: flex; // 改为Flex布局，替代浮动
  justify-content: space-between; // 左右分栏，中间留间隙
  align-items: flex-start; // 顶部对齐
  gap: 2%; // 左右栏间隙，避免贴边

  // 平板适配：换行显示
  @media (max-width: 992px) {
    flex-direction: column;
    gap: 30px;
    padding: 0 10px;
  }
  // 手机适配
  @media (max-width: 480px) {
    gap: 20px;
    padding: 0 5px;
  }
}

/* 左侧文章内容 */
.art-content{
  width: 72%; // 左侧占72%
  margin-top: 50px;

  // 平板适配：占100%
  @media (max-width: 992px) {
    width: 100%;
    margin-top: 30px;
  }
  // 手机适配
  @media (max-width: 480px) {
    width: 100%;
    margin-top: 20px;
  }
}

.art-content h1{
  padding: 20px 10px;
  font-size: 24px;
  line-height: 28px;
  font-weight: bold;
  border-bottom: 1px solid #e5e5e5;

  // 平板适配
  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 24px;
    padding: 15px 8px;
  }
  // 手机适配
  @media (max-width: 480px) {
    font-size: 18px;
    line-height: 22px;
    padding: 10px 5px;
  }
}

.art-time {
  padding: 20px 10px;

  // 手机适配
  @media (max-width: 480px) {
    padding: 15px 5px;
  }
}

.art-time span{
  display: inline-block;
  vertical-align: top;
  color: #999;
  font-size: 14px;

  // 手机适配
  @media (max-width: 480px) {
    font-size: 12px;
  }
}

// 富文本内容区域（核心：优化移动端显示）
.art-body{
  padding: 20px 10px;
  line-height: 1.8; // 增加行高，提升可读性

  // 手机适配
  @media (max-width: 480px) {
    padding: 15px 5px;
    line-height: 1.7; // 移动端适当减小行高，节省空间
  }

  // 穿透样式：限制v-html渲染的图片不超宽
  :deep(img) {
    max-width: 100% !important; // 强制不超过容器宽度
    height: auto !important;    // 保持图片比例，避免拉伸
    display: block;             // 清除行内图片的底部间隙
    margin: 0 auto 15px;        // 图片居中 + 底部间距（移动端减小）
    object-fit: contain;        // 保证图片完整显示
  }

  :deep(p) {
    margin-bottom: 15px;
    font-size: 16px;
    color: #666;
    text-align: justify;
    line-height: 1.8;

    // 平板适配
    @media (max-width: 768px) {
      font-size: 14px;
      margin-bottom: 12px;
    }
    // 手机适配
    @media (max-width: 480px) {
      font-size: 13px;
      margin-bottom: 10px;
      line-height: 1.6;
    }
  }

  // 富文本其他元素适配
  :deep(h2), :deep(h3), :deep(h4) {
    margin: 15px 0 10px;
    line-height: 1.5;

    @media (max-width: 480px) {
      margin: 10px 0 8px;
      font-size: 1.2em !important;
    }
  }

  :deep(ul), :deep(ol) {
    padding-left: 20px;
    margin-bottom: 15px;

    @media (max-width: 480px) {
      padding-left: 15px;
      margin-bottom: 10px;
    }
  }
}

/* 分页区域（修复div样式，替代原有li） */
.turn-page{
  position: relative;
  margin-top: 50px;
  padding: 20px 10px;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;

  // 平板适配
  @media (max-width: 768px) {
    margin-top: 30px;
    padding: 15px 8px;
  }
  // 手机适配
  @media (max-width: 480px) {
    margin-top: 20px;
    padding: 15px 5px;
  }
}

.turn-page .prev-article,
.turn-page .next-article {
  font-size: 16px;
  color: #666;
  line-height: 32px;
  margin-bottom: 10px; // 上下篇换行间距

  // 手机适配
  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 28px;
    margin-bottom: 8px;
  }
}

.turn-page a {
  color: #666;
  text-decoration: none;
  font-size: 16px;

  // 手机适配
  @media (max-width: 480px) {
    font-size: 14px;
  }
}

//.turn-page a:hover {
//  color: #d26b6b;
//  text-decoration: underline;
//}

.turn-page .back{
  position: absolute;
  top: 50%;
  right: 20px;
  width: 150px;
  height: 40px;
  margin-top: -20px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  background: #d26b6b;
  border-radius: 3px;
  text-decoration: none; // 清除下划线

  // 平板适配
  @media (max-width: 768px) {
    position: static;
    display: block;
    width: 100%;
    margin: 20px auto 0;
  }
  // 手机适配
  @media (max-width: 480px) {
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    margin: 15px auto 0;
  }
}

/* 右侧相关新闻（固定右侧，占25%） */
.relate-news{
  width: 25%; // 右侧占25%
  margin-top: 50px;
  padding: 0 10px 30px;
  background: #fafafa;
  border-radius: 4px; // 轻微圆角，提升视觉

  // 平板适配：占100%
  @media (max-width: 992px) {
    width: 100%;
    margin-top: 0;
    padding: 15px 15px 30px;
  }
  // 手机适配
  @media (max-width: 480px) {
    width: 100%;
    margin-top: 0;
    padding: 10px 10px 20px;
  }
}

.relate-news h2{
  height: 60px;
  padding: 0 6px;
  line-height: 60px;
  font-size: 18px;
  color: #666;
  font-weight: bold;
  border-bottom: 1px solid #e5e5e5;

  // 手机适配
  @media (max-width: 480px) {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    padding: 0 5px;
  }
}

.relate-news h2 a{
  float: right;
  color: #999;
  text-decoration: none;
  font-size: 14px;

  // 手机适配
  @media (max-width: 480px) {
    font-size: 12px;
  }
}

.relate-news h2 a:hover{
  color: #d26b6b;
}

.relate-news ul{
  padding: 0 10px;
  list-style: none; // 清除默认列表样式

  // 手机适配
  @media (max-width: 480px) {
    padding: 0 5px;
  }
}

.relate-news ul li{
  padding: 15px 0;
  overflow: hidden;
  border-bottom: 1px dotted #c8c8c8;

  // 手机适配
  @media (max-width: 480px) {
    padding: 12px 0;
  }
}

.relate-news ul li a {
  display: flex; // 时间+标题横向排列
  align-items: center;
  text-decoration: none; // 清除下划线
}

.relate-news ul li p{
  flex: 0 0 58px; // 固定时间宽度
  margin-right: 15px;
  text-align: center;

  // 手机适配：减小时间块宽度
  @media (max-width: 480px) {
    flex: 0 0 48px;
    margin-right: 10px;
  }
}

.relate-news ul li span{
  display: block;
  line-height: 30px;
  background: #d26b6b;
  color: #fff;
  border-radius: 3px 3px 0 0;

  // 手机适配
  @media (max-width: 480px) {
    line-height: 24px;
    font-size: 12px;
  }
}

.relate-news ul li em{
  display: block;
  line-height: 30px;
  background: #efefef;
  color: #b4b4b4;
  border-radius: 0 0 3px 3px;

  // 手机适配
  @media (max-width: 480px) {
    line-height: 24px;
    font-size: 12px;
  }
}

.relate-news ul li h3{
  flex: 1; // 标题占剩余宽度
  color: #999;
  line-height: 20px;
  transition: all 0.3s;
  font-size: 14px; // 调整字体大小，避免溢出
  font-weight: normal; // 取消粗体

  // 手机适配：优化标题显示
  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 18px;
    display: -webkit-box;
    -webkit-line-clamp: 2; // 最多显示2行
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

.relate-news ul li:hover h3{
  color: #333;
}
</style>